<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-esc="escape" v-model="isActive">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ newLossReason.id == 0 ? "Yeni Zayiat Sebebi" : "Zayiat Sebebi Düzenle" }}</h4>
      <feather-icon icon="XIcon" @click.stop="isActive = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center" class="px-6 mb-4 mt-4">
        <vs-input name="Sebep" v-validate="{required:true}" v-model="newLossReason.name" class="w-full"
          label-placeholder="İsim" />
        <span class="text-danger text-sm" v-show="errors.has('Sebep')">{{ errors.first('Sebep') }}</span>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
        <vs-col vs-type="flex" vs-w="6" class="px-1" vs-justify="center" vs-align="center">
          <vs-button type="gradient" color="danger" @click="initValues();">
            Vazgeç
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-w="6" class="px-1" vs-justify="center" vs-align="center">
          <vs-button color="success" @click="submitData">Kaydet</vs-button>
        </vs-col>
      </vs-row>
    </VuePerfectScrollbar>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  export default {
    data() {
      return {
        newLossReason: {
          id: 0,
          name: null
        },
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
        isActive: false
      }
    },
    computed: {

    },
    methods: {
      escape() {
        if (this.isActive = true) this.isActive = false;
      },
      initValues() {
        this.newLossReason = {
          id: 0,
          name: null
        };
        this.isActive = false;
      },
      submitData: async function () {
        let checker = await this.$validator.validateAll();
        if (!checker) return;

        if (this.newLossReason.id == 0) {
          this.$store.dispatch("lossReason/addLossReason", this.newLossReason).then(res => {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "İşlem Başarılı !"
            });
            this.initValues();
          }).catch(error => {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: error
            });
          });
        } else if (this.newLossReason.id > 0) {
          this.$store.dispatch("lossReason/updateLossReason", this.newLossReason).then(res => {
            this.$vs.notify({
              color: "success",
              title: "Başarılı !",
              text: "İşlem Başarılı !"
            });
            this.initValues();
          }).catch(error => {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: error
            });
          });
        }
      },
    },
    components: {
      VuePerfectScrollbar,
    }
  }

</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
    }
  }

</style>
